import React from 'react';

const VimeoIcon: React.FC = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3275 5.03055C15.2622 6.461 14.2651 8.41975 12.3364 10.9058C10.3423 13.5027 8.65519 14.801 7.27505 14.801C6.42042 14.801 5.69661 14.0104 5.10584 12.4288C4.71101 10.979 4.31662 9.5293 3.92193 8.07948C3.48296 6.4987 3.0123 5.70728 2.50909 5.70728C2.39938 5.70728 2.0154 5.93857 1.35804 6.3994L0.667969 5.50869C1.39177 4.87142 2.1059 4.23429 2.80843 3.59628C3.7738 2.76042 4.49848 2.32086 4.98146 2.27642C6.12298 2.16656 6.82551 2.9483 7.08922 4.62179C7.3742 6.42727 7.57132 7.55031 7.6822 7.98987C8.01117 9.48779 8.37315 10.2358 8.76871 10.2358C9.07569 10.2358 9.53681 9.75003 10.1516 8.7785C10.7659 7.80668 11.0948 7.06733 11.1393 6.55942C11.2267 5.72077 10.8976 5.30042 10.1516 5.30042C9.80052 5.30042 9.43854 5.38138 9.06615 5.54139C9.78688 3.17579 11.1641 2.02694 13.1969 2.0925C14.7039 2.13679 15.4143 3.11609 15.3275 5.03055Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default VimeoIcon;
